import React from "react"
import styled from '@emotion/styled/macro'
import { StaticImage } from "gatsby-plugin-image"
import { CallToActionPolygon, Call } from "../SVGs"
import { Theme2, Device } from "../Layout"
import { useCommonItemsQuery } from '../../hooks/use-common-items-query'

const CalloutLargerText = styled.p`
font-size: 31px;
line-height: 35px;
  font-family: ${Theme2.fonts.headings};
  margin-bottom: 0.25em;
  font-weight: 700;
  @media ${Device.md}{
    font-size: calc(31px + 9 * ((100vw - 768px) / 432));
    line-height: calc(35px + 9 * ((100vw - 768px) / 432));
    margin-bottom: 0.5em;
  }
  @media ${Device.xl}{
    font-size: 40px;
    line-height: 44px;
  }
`
const CalloutSubheading = styled.p`
font-family: ${Theme2.fonts.alternateHeadings};
font-size: 16px;
font-style: italic;
margin-bottom: 0.5em;

@media ${Device.md}{
font-size: 25px;
margin-bottom: 0.75em;
}
`
const PhoneButton = styled.a`
color: ${Theme2.colors.light};
display: flex;
text-decoration: none;
background-color: ${Theme2.colors.tertiary};
width: auto;
max-width: 280px;
align-items: center;
justify-content: center;
padding: 23px;
box-sizing: border-box;
`
const PhoneNumberText = styled.p`
margin: 0 0 0 22px;
font-size: 20px;

@media ${Device.md}{
  font-size: 23px;
}
`
const CalloutContainer = styled.div` 
display: grid;
grid-template-columns: 50% 50%;
color: ${Theme2.colors.light};

svg.callToActionPolygon{
  display: none;
  max-width: 100%;
  grid-area: 1 / 1;
  @media ${Device.md}{
    display: block;
  }
}
`
const CalloutTextAndPolygonContainer = styled.div`
grid-area: 1 / 1 / span 1 / span 2;
position: relative;
display: grid;
`
const CalloutTextContainer = styled.div`
grid-area: 1 / 1 / span 1 / span 1;
display: flex;
flex-direction: column;
justify-content: center;
margin: 10%;

@media ${Device.md}{
width: 50%;
margin: 0;
margin-left: 5%;
}

`
const InteriorPageCallout = ({calloutImageAltText}) =>{
  const { commonItemsCalloutLargerText,  commonItemsCalloutSubheading, commonItemsOffices} = useCommonItemsQuery()
  const tel = "tel:"
  const phoneNumber = commonItemsOffices[0].commonItemsPhone
  const phoneNumberHref = tel+phoneNumber
return(
<CalloutContainer>
<StaticImage style={{gridArea: "1 / 1 / span 1 / span 2", maxHeight: 427}} layout="fullWidth" src="../../images/interior-cta-background.jpg" alt={calloutImageAltText} formats={["auto", "webp", "avif"]}/>
<CalloutTextAndPolygonContainer>
<CallToActionPolygon />
<CalloutTextContainer>
<CalloutLargerText>
{commonItemsCalloutLargerText}
</CalloutLargerText>
<CalloutSubheading>
{commonItemsCalloutSubheading}
</CalloutSubheading>
<PhoneButton href={phoneNumberHref}>
<Call />
<PhoneNumberText>
  {phoneNumber}
</PhoneNumberText>
</PhoneButton>
</CalloutTextContainer>
</CalloutTextAndPolygonContainer>
      </CalloutContainer>
)
}

export default InteriorPageCallout